export default "__VITE_ASSET__CTQgf3cE__"